<template>
  <a-modal
    :visible="visible"
    :title="$t('page_business_import_material')"
    :ok-text="$t('ok')"
    :cancel-text="$t('close')"
    :width="800"
    @cancel="() => handleCancel()"
  >
    <template slot="footer">
      <a-button key="back" :loading="loading" @click="() => handleCancel()">
        {{ $t('cancel')}}
      </a-button>
      <a-button :loading="loading" type="default" @click="() => download()">
        {{ $t('download_import_template')}}
      </a-button>
      <a-button :loading="loading" type="primary" @click="() => handleOk()">
        {{ $t('save')}}
      </a-button>
    </template>
    <a-upload-dragger
      name="file"
      :multiple="false"
      :before-upload="file => this.beforeUpload(file)"
      :file-list="this.fileList"
      :remove="file => this.handleRemove(file)"
    >
      <p class="ant-upload-drag-icon">
        <a-icon type="inbox" />
      </p>
      <p class="ant-upload-text">
        {{$t('page_my_document_upload_here')}}
      </p>
      <p class="ant-upload-hint">
        {{$t('page_firmware_management_support_extend')}}: .xls、.xlsx
      </p>
    </a-upload-dragger>
  </a-modal>
</template>

<script>
import { importMaintainItem, exportMaintainItemTemplate } from '@/api/api'
import { downloadFile } from '@/utils/index'

export default {
  props:{
    visible:{
      type: Boolean,
      default: false
    },
  },
  data(){
    return {
      loading: false,
      fileList: []
    }
  },
  methods:{
    download() {
      exportMaintainItemTemplate().then(res =>{
        // 创建隐藏的可下载链接
        var a = document.createElement('a')
        a.download = `${this.$t('page_plan_maintenance_items')}.xlsx`
        a.style.display = 'none'
        // 字符内容转变成blob地址
        // var blob = new Blob([res])
        let url = URL.createObjectURL(res)
        a.href = url
        // 触发点击
        document.body.appendChild(a)
        a.click()
        // 然后移除
        URL.revokeObjectURL(url)
        document.body.removeChild(a)
      })
    },
    handleCancel() {
      this.fileList = []
      this.$emit('close',false)
    },
    beforeUpload(file) {
      const isGt20M = file.size / 1024 / 1024 > 20
      if (isGt20M) {
        this.$message.error(this.$t('page_my_document_notsupport'))
        return false
      }
      this.fileList = [file]
      return false;
    },
    handleOk() {
      if(!this.fileList.length) {
        this.$message.warning(this.$t('page_my_document_select'))
        return
      }
      this.loading = true
      const formData = new FormData()
      formData.append('file', this.fileList[0])
      importMaintainItem(formData).then(res => {
        let reader = new FileReader()
        reader.readAsText(res)
        const that = this
        reader.onload = e => {
          if(reader.result == "") {
            that.$message.success(that.$t('page_material_check_success_tip'))
            that.fileList = []
            that.loading = false
            that.$emit('close',true)
          } else {
            downloadFile(res, `${that.$t('page_plan_maintenance_items')}.xlsx`)
          }
        }
      })
      setInterval(() => {
        this.loading = false
      }, 1000);
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    }
  }
}
</script>

<style>

</style>